// extracted by mini-css-extract-plugin
export var iconContainer = "_bx-0";
export var metricCardsContainer = "_bx-1";